module.exports = __webpack_public_path__ + "static/media/recluta_local_2022_v1.3716e8c0.m4v";